import React from "react";
import Zestawieniahtml_3 from './Zestawienia_html 3.js';
import PrintComponents from "react-print-components";
import './tabela.css';


export default class Print3 extends React.Component {
    constructor(props) {
        super();
        this.state = { data: props.data }
    }

    render() {
        let { data, stalytekst } = this.state
        return (
        <PrintComponents trigger={<button type="button" class="btn btn-light float-right mr-5"><i class="fas fa-print"></i> Drukuj</button>} >
        <Zestawieniahtml_3 data={data}  grupaZestawienValuetext={this.props.grupaZestawienValuetext}/>   
        </PrintComponents>
        );
    }
}
